import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import contentSagas from './content/saga';
import productSagas from './products/saga';
import cartSagas from './cart/saga';
import addressSagas from './address/saga';
import orderSagas from './orders/saga';
import reviewSagas from './reviews/saga';
import wishlistSaga from './wishlists/saga';
import paymentSaga from './payment/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    contentSagas(),
    productSagas(),
    cartSagas(),
    addressSagas(),
    orderSagas(),
    reviewSagas(),
    wishlistSaga(),
    paymentSaga(),
  ]);
}
